import { useContext, useState } from "react";
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { AbsoluteContainer, Button, CustomContainer, FixedContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import successGif from "src/assets/gif/success.json";
import successConfetti from "src/assets/gif/successConfetti.json"
import Lottie from "lottie-react"
import { RiCloseFill } from "react-icons/ri";

export const SuccessNotif: React.FC<any> = () => {
    const { visibility: {notification}, notifier } = useContext(VisibilityContext)

    function handleCloseNotifier () {
        notifier.hide()
    }

    return (
        <FixedContainer height='full' width='100' sizeUnit='%' top='0' left='0' zIndex='15'>
            <GridContainer 
                width='100' sizeUnit='%' height='100' hUnit='%' 
                bgColor='rgba(0,0,0, 0.3)'
                onClick={handleCloseNotifier}
            >
                <CustomContainer 
                    width='38.4' minHeight='37' radius='1' 
                    bgColor='#ffffff' padding='2' topPadding="1"
                    overflow='auto'
                    shadow='0px 24px 56px rgba(0, 23, 69, 0.04)'
                    className={`popup-main-container popup-main-container-d2`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <AbsoluteContainer top="0" left='0'>
                        <Lottie animationData={successConfetti} loop={true} />
                    </AbsoluteContainer>
                    
                    <FlexRow justifyContent="flex-end" bottomMargin="0.5">
                        <Button 
                            titleSize="2" fontWeight="500"
                            width='3.4' shadow='none'
                            height='3.4'
                            radius='0.6'
                            bgColor='#ffffff'
                            hoverBgColor='#FEF3F2'
                            borderColor='none'
                            color='#000000'
                            hoverColor='#B42318'
                            onClick={handleCloseNotifier}
                        >
                            <RiCloseFill fontSize='2.3rem' />
                        </Button>
                    </FlexRow>

                    <CustomContainer 
                        className="popup-content-container"
                    >
                        <GridContainer 
                            topMargin="1.5" 
                        >
                            <CustomContainer width="20" topMargin="-4">
                                <Lottie animationData={successGif} loop={true} />
                            </CustomContainer>
                            <ScreenTitle 
                                textSize="2.2" fontWeight="700" align="center"
                                topMargin="0.5" fontFamily="Gilmer-Bold"
                            >
                                {notification.message || 'Success'}
                            </ScreenTitle>
                            <Button 
                                width='100' sizeUnit="%" height='4.4' topMargin="2.5"
                                borderColor='#0D968F' hoverBgColor='#ffffff' 
                                hoverColor='#0D968F' titleSize='1.4'
                                onClick={handleCloseNotifier}
                            >
                                Dismiss
                            </Button>
                        </GridContainer>
                    </CustomContainer>
                </CustomContainer>
            </GridContainer>
        </FixedContainer>
    )
}